import React from "react";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./NotFound.scss";
import ImageLogo from "../../images/hyper-full-white.svg";
import FixedFooter from "../../components/FixedFooter/FixedFooter";
import GetAppButton from "../../components/GetAppButton/GetAppButton";
import FilledButton, {
  ButtonSizes,
} from "../../components/dashboard-page/FilledButton/FilledButton";
import ImageVerticalCardCarousel from "../../images/vertical-card-carousel.png";
import { ROUTES } from "../../utils/constants";
import useDisclosure from "../../hooks/useDisclosure";
import GetHyperOnTestFlight from "../../components/GetHyperOnTestFlightModal/GetHyperOnTestFlightModal";
import DownloadAndroidAppModal from "../../components/DownloadAndroidAppModal/DownloadAndroidAppModal";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../utils/renderHeaders";
import { ThemeVariant } from "../../utils/constants/generic-types";

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    isOpen: isTestFlightInstructionsOpen,
    onOpen: openTestFlightInstructions,
    onClose: closeTestFlightInstructions,
  } = useDisclosure();
  const {
    isOpen: isAndroidAppDownloadOpen,
    onOpen: openDownloadAndroidApp,
    onClose: closeDownloadAndroidApp,
  } = useDisclosure();
  const handleDownloadApp = (openPlatformDialog: () => void) => {
    openPlatformDialog();
  };

  return (
    <>
      {renderHeaders({
        title: t("metadata:page_not_found_hyper_gaming_app"),
        description: t("metadata:page_not_found_seo_description"),
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:page_not_found_hyper_gaming_app")
        ),
      })}
      <main className="not-found-page MobileOnly">
        <header>
          <div className="logo-container d-flex justify-content-center">
            <Image src={ImageLogo} className="logo mt-4" />
          </div>
          <Image src={ImageVerticalCardCarousel} className="thumbnails" />
        </header>
        <section className="pt-5 px-3">
          <h1 className="mb-2">Oops!!! You seem lost</h1>
          <p>
            Get the app for the best experience! Play hundreds of games with
            thousands of gamers, ad-free. Or explore our games here.
          </p>
          <FixedFooter className="px-3">
            {/* TODO: Refactor GetAppButton so we don't need to functions / values for it to work properly */}
            <GetAppButton
              openDownloadAndroidApp={() =>
                handleDownloadApp(openDownloadAndroidApp)
              }
              openTestFlightInstructions={() =>
                handleDownloadApp(openTestFlightInstructions)
              }
            />
            <FilledButton
              fullwidth
              size={ButtonSizes.MD}
              className="mt-3"
              style={{ background: "#191040" }}
              onClick={() => navigate(`${ROUTES.GAMES.ROOT}`)}
            >
              Go to Games
            </FilledButton>
          </FixedFooter>
        </section>
        <GetHyperOnTestFlight
          isOpen={isTestFlightInstructionsOpen}
          onClose={closeTestFlightInstructions}
          theme={ThemeVariant.DARK}
        />
        <DownloadAndroidAppModal
          isOpen={isAndroidAppDownloadOpen}
          onClose={closeDownloadAndroidApp}
        />
      </main>
    </>
  );
}

export default NotFound;
